import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'

//import logo from './logo.svg';
import './css/mws.css';

import WebHome from './web/home.js';
import WebLogout from './web/logout.js';
import WebStd from './std/std.js';

import WebHka from './hka/hka.js';
import WebPos from './pos/pos.js';

import WebCsc from './csc/csc.js';
import WebCsd from './csd/csd.js';
import WebCsg from './csg/csg.js';

import Store, { StoreProvider } from "./data/sdo";
import WebStore from "./data/ado";

import sso from "./sso.js";

const webStore = new WebStore();
const store = new Store();

function MwsApp() {
    //var sdo = useContext(SDO);

    const[txt, setTxt] = useState("SS00");

    var sdo = {};
    sdo.fid = "11";
    sdo.text = txt;
    sdo.setText = setTxt;
    //alert(JSON.stringify(sdo));
    var xdo = sessionStorage.getItem("svp");
    //alert(xdo);
    var seo = JSON.parse(xdo);
    sso.seo = seo;

    if(!xdo) {
        webStore.seo = {};
        webStore.seo.loggedin = false;
        var html =
        <BrowserRouter forceRefresh={true}>
            <Routes>
                <Route path="/hka/*" forceRefresh={true} element={ <WebHka store={webStore} />} />
                <Route path="*" forceRefresh={true} element={ <WebHome store={webStore} />} />
            </Routes>
        </BrowserRouter>
        return html;
    }

    if(xdo) {
        var seo = JSON.parse(xdo);
        webStore.seo = seo;
        //return routefkn(sdo);
    }

    var pos = {};
    webStore.pos = pos;
    var ta = {};
    webStore.ta = ta;

    var html =
    <StoreProvider store={store}>
    <BrowserRouter>
        <Routes>
            <Route path="/csc/*" forceRefresh={true} element={ <WebCsc store={webStore} />} />
            <Route path="/csd/*" forceRefresh={true} element={ <WebCsd store={webStore} />} />
            <Route path="/csg/*" forceRefresh={true} element={ <WebCsg store={webStore} />} />
            <Route path="/hka/*" forceRefresh={true} element={ <WebHka store={webStore} />} />
            <Route path="/pms/*" forceRefresh={true} element={ <WebPos store={webStore} />} />
            <Route path="/pos/*" forceRefresh={true} element={ <WebPos store={webStore} />} />
            <Route path="/std/*" forceRefresh={true} element={ <WebPos store={webStore} />} />
            <Route path="/logout" forceRefresh={true} element={ <WebLogout store={webStore} />} />
            <Route path="*" forceRefresh={true} element={ <WebHome store={webStore} />} />
        </Routes>
    </BrowserRouter>
    </StoreProvider>
    return html;
}

export default MwsApp;
